<template>
<div class="body-main">
  <div class="header">
<!--    <el-button size="mini" @click="editor()">添加</el-button>-->
    <el-input v-model="where2.keyword" style="width: 200px;margin-left: 10px;" size="mini" placeholder="请输入名称" clearable></el-input>
    <el-select v-model="where2.status" class="m-2" filterable placeholder="选择状态" clearable style="margin-left: 10px;" size="mini">
      <el-option
        v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading" :data="pageData.data"
      border
      @sort-change="onSorTable"
      style="width: 100%" height="60vh">
      <el-table-column
        prop="project_name"
        label="项目"
        width="200" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column
        prop="company_name"
        label="第三方单位名称" width="240" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column align="center"
                       prop="contact_name"
                       label="对接人"
                       width="150">
      </el-table-column>
      <el-table-column align="center"
                       prop="contact_telephone"
                       label="对接人电话"
                       width="150">
      </el-table-column>
      <el-table-column align="center"
                       prop="contact_file"
                       label="合同附件"
                       width="150">
        <template slot-scope="scope">
          <el-link v-if="scope.row.contact_file" type="primary" size="mini" @click="$refs.viewFileListRef.show(scope.row.contact_file)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       prop="bank_card"
                       label="收款账户"
                       width="200">
      </el-table-column>
      <el-table-column align="center"
                       prop="bank_name"
                       label="开户行"
                       width="200">
      </el-table-column>
      <el-table-column align="center"
                       prop="online_service_rate"
                       label="在管-服务费率(%)"
                       width="150"></el-table-column>
      <el-table-column align="center"
                       prop="online_ss_service_rate"
                       label="在管-诉讼费率(%)"
                       width="150"></el-table-column>
      <el-table-column align="center"
                       prop="offline_service_rate"
                       label="撤场-服务费率(%)"
                       width="150"></el-table-column>
      <el-table-column align="center"
                       prop="offline_ss_service_rate"
                       label="撤场-诉讼费率(%)"
                       width="150"></el-table-column>
      <el-table-column align="center"
                       prop="start_time"
                       label="开始时间" sortable="custom" width="150">
      </el-table-column>
      <el-table-column align="center" sortable="custom"
                       prop="end_time"
                       label="结束时间"
                       width="150">
      </el-table-column>
      <el-table-column align="center"
                       prop="execution_date"
                       label="合作签订时间"
                       width="150">
      </el-table-column>
      <el-table-column align="center"
                       prop="company_day"
                       label="合同时长（天）"
                       width="150">
      </el-table-column>

      <el-table-column align="center"
        prop="status"
        label="状态"
        width="100">
        <template slot-scope="scope">
          {{scope.row.status?'合作中':'终止合作'}}
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="created_at"-->
<!--        label="创建时间"-->
<!--        width="100">-->
<!--      </el-table-column>-->
      <el-table-column align="center" sortable="custom"
        prop="updated_at"
        label="更新时间"
        width="100">
      </el-table-column>
      <el-table-column align="center"
        label="	操作"
        min-width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editor(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="stop(scope.row)">终止合作</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination
      @current-change="pageChange"
      :current-page="pageData.current_page"
      :page-size="pageData.per_page"
      layout="total, prev, pager, next"
      :total="pageData.total">
    </el-pagination>
  </div>
  <CompanyProjectEditor ref="companyProjectEditorRef" />
  <ViewFileList ref="viewFileListRef" />
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import CompanyProjectEditor from "./components/CompanyProjectEditor";
import ViewFileList from "../../../Common/ViewFileList";

export default {
  name: "CompanyProject",
  components: {ViewFileList, CompanyProjectEditor},
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      where2:{
        keyword:"",
        status:"",
        order_by:"",
      },
      pageData: {
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      loading: false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)
      where = {
        ...where,
        ...ERP.reJson(that.where),
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        // area_id:that.areaId
      }

      ButlerHttp.post("ProjectCollectionThridCompanyProjectContract/index?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page, {
        ...where,
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.current_page = i
      this.getList()
    },
    editor(item=null){
      const that=this;
      that.$refs.companyProjectEditorRef.show(item, (data) => {
        that.getList();
      })
    },
    stop(){
      const that = this;
      that.$confirm('停止第三方合作的前提是当前合作商无催缴房产了，确定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = ERP.reJson(that.formData)
        ButlerHttp.post("ThirdPartyLegal/getProjectCompanyStop", {
          id: formData.id
        }, res => {
          if (res.code) {
            that.pageChange(1);
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },

    deleteItem(item){
      const that=this;

      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyDel", {
        id: item.id
      }, res => {
        if (res.code) {
          that.getList();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    onSorTable({column, prop, order}){
      console.log({column, prop, order})
      const that=this;
      if(order){
        let orderProp={
          "project_name":"cp.project_name",
          "company_name":"c.name",
          "start_time":"cp.start_time",
          "end_time":"cp.end_time",
          "house_count":"cp.house_count",
          "house_money":"cp.house_money",
          "collection_num":"cps.collection_num",
          "collection_house_num":"cps.collection_house_num",
          "collection_house_rate":"cps.collection_house_rate",
          "payment_collection_num":"cps.payment_collection_num",
          "payment_collection_amount":"cps.payment_collection_amount",
          "payment_collection_rate":"cps.payment_collection_rate",
          "cumulative_collection_num":"cps.cumulative_collection_num",
          "cumulative_collection_house_num":"cps.cumulative_collection_house_num",
          "cumulative_collection_house_rate":"cps.cumulative_collection_house_rate",
          "cumulative_payment_collection_num":"cps.cumulative_payment_collection_num",
          "cumulative_payment_collection_amount":"cps.cumulative_payment_collection_amount",
          "cumulative_payment_collection_rate":"cps.cumulative_payment_collection_rate",
          "updated_at":"cp.updated_at",
        }
        let sortOrder = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端期望的格式（例如 'asc'/'desc'）
        let field=orderProp[prop]||null
        if(field) {
          that.where2.order_by=`${field} ${sortOrder}`
        }else {
          that.where2.order_by=''
        }
      }else {
        that.where2.order_by=''
      }
      that.pageChange(1);

    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "where2.keyword":function (n,o) {
      this.pageChange(1)
    },
    "where2.status":function (n,o) {
      this.pageChange(1)
    },
    "where.thrid_company_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body-main{
  .header{
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }
  .table-wrap{
    >>>.el-table--border, .el-table--group{
      border: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
      border-right: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
      border-bottom: 1px solid #000000;
    }
  }
  .pagination-wrap{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_common/CompanyProject.vue